export const Eyebrow = ({ children, className = "", ruled = false, ...rest }) => {
  if (!ruled) return <p className={`eyebrow ${className}`} {...rest}>{children}</p>;
  return (
    <div className={`flex items-center justify-center gap-2 sm:gap-3 ${className}`} {...rest}>
      <span className="fade-rule-l w-5 shrink-0 sm:w-16" aria-hidden="true" />
      <span className="eyebrow text-center">{children}</span>
      <span className="fade-rule-r w-5 shrink-0 sm:w-16" aria-hidden="true" />
    </div>
  );
};

export const GoldText = ({ children, className = "" }) => <span className={`gold-text ${className}`}>{children}</span>;

export const ChromeHeading = ({ as: Tag = "h2", children, className = "", ...rest }) => (
  <Tag className={`chrome-text ${className}`} {...rest}>{children}</Tag>
);

export const Card = ({ children, className = "", hover = false, ...rest }) => (
  <div className={`lux-card ${hover ? "lux-card--hover" : ""} ${className}`} {...rest}>{children}</div>
);

export const Section = ({ children, className = "", id, separator = true, ...rest }) => (
  <section id={id} className={`relative ${className}`} {...rest}>
    {separator && <div className="hairline" aria-hidden="true" />}
    <div className="gutter py-20 sm:py-24 lg:py-28">{children}</div>
  </section>
);

export const Diamond = ({ className = "" }) => (
  <span aria-hidden="true" className={`text-[var(--gold)] ${className}`}>◆</span>
);
